import React, { Component } from 'react';
import { Icon, Flag } from 'semantic-ui-react';
import './styles.scss';
import logoUrl from '../../assets/images/logo.png';
import MainNavigation from '../MainNavigation';
import {
  Link
} from "react-router-dom";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import i18n from '../../core/helpers/i18n';  
import { compose } from 'redux';
import { logout } from "../../core/actions/authAction";
import functionCommon from '../../core/common/function';
import { withRouter } from 'react-router-dom';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = { pathName: window.location.pathname + window.location.search };
        props.history.listen((location) => {
            this.setState({
                pathName: location.pathname + location.search,
            });
        });
    }

    hambugerMenu = (e) => {
        e.preventDefault();
        document.body.classList.toggle("nav-open");
    }

    changeLanguage = (lng) => {
        localStorage.removeItem('lng');
        localStorage.setItem('lng', lng);
        i18n.changeLanguage(lng);
    }

    handleLogoutClick = (e) => {
        this.props.logout();
    }

    render() {
        const {t} = this.props;
        const employeeName = functionCommon.getInfoUser('employeeName');

        return (            
            <div>
                <header>
                    <div className="main-header">
                        <div className="logo">
                            <h1><Link to="/"><img src={logoUrl} alt="Project Control Management System"/></Link></h1>
                        </div>
                        <MainNavigation/>
                    </div>
                    <div className="right-nav">
                        <ul>
                            <li className="account-selector">
                                <Link to={this.state.pathName}>
                                    <Icon name='user' />{functionCommon.getInfoUser('employeeCodeSimple') + '-' + functionCommon.convertVie(employeeName)}
                                    <Icon name='caret down' />
                                </Link>
                                <ul>
                                    <li>
                                        <Link to="/change-password">{t("account.changePassword")}</Link>
                                    </li>
                                    <li>
                                        <Link to="javascript:void(0);" onClick={(e) => this.handleLogoutClick(e)}>
                                            {t("common.logout")}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="lang-selector">
                                <Link to={this.state.pathName}>
                                    <Flag name={localStorage.getItem('i18nextLng') === 'en' ? 'gb' : 'vn'} />
                                    <span>{localStorage.getItem('i18nextLng') === 'en' ? 'EN' : 'VI'}</span>
                                    <Icon name='caret down' />
                                </Link>
                                <ul>
                                    <li>
                                        <Link to={this.state.pathName} onClick={() => this.changeLanguage('en')} >
                                            <Flag name='gb' /><span>EN</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={this.state.pathName} onClick={() => this.changeLanguage('vi')}>
                                            <Flag name='vn' /><span>VI</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <button className="hambuger-menu" onClick={this.hambugerMenu}>
                            <span>Menu</span>
                        </button>
                    </div>
                </header>
                <div className="mobile-nav">
                    <MainNavigation/>
                    <div className="bottom-nav">
                        <div className="mobile-account">
                            <Link to="/change-password">{t("account.changePassword")}</Link>
                            <Link to="javascript:void(0);" onClick={(e) => this.handleLogoutClick(e)}>
                                {t("common.logout")}
                            </Link>
                        </div>
                        <div className="mobile-lang">
                            <Link to={this.state.pathName} onClick={() => this.changeLanguage('en')}><Flag name='gb' /><span>EN</span></Link>
                            <Link to={this.state.pathName} onClick={() => this.changeLanguage('vi')}><Flag name='vn' /><span>VI</span></Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logout())
})

export default withRouter(compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(Header));
